import React from "react";
import { Link } from "react-router-dom";
import { MapPin, Phone, Mail, Clock, MessageCircle, Instagram } from "lucide-react";
import { useLang } from "@/contexts/LanguageContext";
import { useContent } from "@/contexts/ContentContext";

export const Footer = () => {
  const { t } = useLang();
  const { c } = useContent();
  return (
    <footer className="relative z-10 border-t border-[var(--vl-border)] bg-[var(--vl-obsidian)]" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 py-16 grid grid-cols-1 md:grid-cols-3 gap-12">
        <div>
          <img src="/veloura-logo.png" alt="Veloura" className="vl-logo h-14 w-auto" />
          <p className="text-sm text-[var(--vl-stone)] mt-5 leading-relaxed max-w-xs">{c("about_text", "")}</p>
        </div>
        <div className="space-y-3">
          <h4 className="font-serif-display text-xl text-[var(--vl-ivory)] mb-4">{t("nav_location")}</h4>
          <p className="flex items-start gap-3 text-sm text-[var(--vl-stone)]"><MapPin size={16} className="text-[var(--vl-gold)] mt-0.5" /> Königstraße 36, 70173 Stuttgart</p>
          <a href="https://wa.me/4915234255157" target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 text-sm text-[var(--vl-stone)] hover:text-[var(--vl-gold)] transition-colors"><MessageCircle size={16} className="text-[var(--vl-gold)]" /> WhatsApp +49 152 342 55 157</a>
          <a href="tel:+4971188234737" className="flex items-center gap-3 text-sm text-[var(--vl-stone)] hover:text-[var(--vl-gold)] transition-colors"><Phone size={16} className="text-[var(--vl-gold)]" /> +49 711 88 23 47 37</a>
          <a href="mailto:theicon@velouraeuropa.com" className="flex items-center gap-3 text-sm text-[var(--vl-stone)] hover:text-[var(--vl-gold)] transition-colors"><Mail size={16} className="text-[var(--vl-gold)]" /> theicon@velouraeuropa.com</a>
          <a href="https://instagram.com/veloura_europa" target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 text-sm text-[var(--vl-stone)] hover:text-[var(--vl-gold)] transition-colors"><Instagram size={16} className="text-[var(--vl-gold)]" /> @veloura_europa</a>
        </div>
        <div className="space-y-3">
          <h4 className="font-serif-display text-xl text-[var(--vl-ivory)] mb-4 flex items-center gap-2"><Clock size={18} className="text-[var(--vl-gold)]" /> {t("opening_hours")}</h4>
          <p className="text-sm text-[var(--vl-stone)]">{t("hours_week")}</p>
          <p className="text-sm text-[var(--vl-stone)]">{t("hours_sat")}</p>
          <p className="text-sm text-[var(--vl-stone)]">{t("hours_sun")}</p>
          <Link to="/admin/login" className="inline-block mt-4 text-xs tracking-widest uppercase text-[var(--vl-stone)]/60 hover:text-[var(--vl-gold)] transition-colors" data-testid="footer-admin-link">
            {t("nav_admin")}
          </Link>
        </div>
      </div>
      <div className="border-t border-[var(--vl-border)] py-6 text-center text-xs text-[var(--vl-stone)]/50 tracking-wider">
        © {new Date().getFullYear()} Veloura Couture & Bridal · www.veloura.de
      </div>
    </footer>
  );
};

export default Footer;
